<template>
<div class="wl-pro-intro-main-wrapper">
    <div class="ph-head-menu">
        <i class="wl-icon-zhuye1" @click="goHome">
            <span>首页</span>
        </i>
        <span>></span>
        <span>{{menuTitle}}</span>
    </div>
    <div class="wl-project-introduction wl-project-introduction-wrapper">
        <div class="wl-certification-lecturer-conte clearfix">
            <div class="wl-sidebar-menu">
                <div class="wl-lecturer-back clearfix" :style="{backgroundImage: 'url(' + (back) + ')'}">
                    <div class="menu-sp-text">I</div>
                    <div class="menu-sp-left">
                        <p class="p-text-tea">项目介绍</p>
                        <p class="p-text-ecturer">NTRODUCE</p>
                    </div>
                </div>
                <ul class="clearfix pro-intro-menu-ul">
                    <li class="pro-intro-ul-li">
                        <router-link :to="{name:'introBase'}" class="a-stand-link" @click.native="changeProIntro('项目介绍')">
                            项目介绍
                            <i class="wl-icon-xiangyou"></i>
                        </router-link>
                    </li>
                    <li class="pro-intro-ul-li">
                        <router-link :to="{name:'introStandard'}" class="a-stand-link" @click.native="changeProIntro('标准建设')">
                            标准建设
                            <i class="wl-icon-xiangyou"></i>
                        </router-link>
                    </li>
                    <li class="pro-intro-ul-li">
                        <router-link :to="{name:'managerWordList'}" class="a-stand-link" @click.native="changeProIntro('管理办法')">
                            管理办法
                            <i class="wl-icon-xiangyou"></i>
                        </router-link>
                    </li>
                    <li class="pro-intro-ul-li">
                        <router-link :to="{name:'examOutLineList'}" class="a-stand-link" @click.native="changeProIntro('考核大纲')">
                            考核大纲
                            <i class="wl-icon-xiangyou"></i>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="wl-certification-content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isTab: 1,
            back: require("assets/images/bg-jieshao.png"),
            TeaAuthenticaList: [],
            menuTitle: "项目介绍"
        };
    },
    created() {},
    methods: {
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        },
        changeProIntro(name) {
            this.menuTitle = name;
        }
    }
};
</script>

<style lang="scss">
.wl-pro-intro-main-wrapper {
    .ph-head-menu {
        display: none;
        padding: 10px 20px 0;
        color: #666;

        span {
            margin: 0 3px;
        }
    }

    .wl-certification-lecturer-conte {
        margin: 0 auto;
        width: 1200px;
    }

    .wl-sidebar-menu {
        float: left;
        width: 220px;
        position: relative;

        .wl-lecturer-back {
            width: 220px;
            height: 120px;
            position: absolute;
            top: 0;
            z-index: 2001;

            .menu-sp-text {
                float: left;
                font-size: 58px;
                color: #0155d1;
                line-height: 120px;
                margin-left: 26px;
            }

            .menu-sp-left {
                float: left;
                margin-top: 40px;
                margin-left: 5px;

                .p-text-tea {
                    color: #fff;
                    font-size: 18px;
                }

                .p-text-ecturer {
                    margin-top: 5px;
                    font-size: 12px;
                    font-weight: bold;
                    color: #0155d1;
                }
            }
        }

        .pro-intro-ul-li {
            margin-bottom: 15px;
        }

        .pro-intro-menu-ul {
            margin-top: 140px;
        }

        .site-menu-con {
            margin-bottom: 10px;
        }

        .a-stand-link {
            display: block;
            width: 220px;
            height: 38px;
            background: #e9ebf0;
            line-height: 38px;
            padding-left: 20px;
            box-sizing: border-box;
            font-size: 16px;
            color: #000;
            cursor: pointer;

            .wl-icon-xiangyou {
                color: #999999;
                float: right;
                margin-right: 16px;
            }

            .rotate {
                transform: rotate(90deg);
            }
        }

        .site-menu-child-li {
            border-top: 1px solid #fff;
        }

        .linkActive {
            background: #2d82ff;
            color: #fff;

            .wl-icon-xiangyou {
                color: #fff;
            }
        }
    }

    .wl-project-introduction {
        .wl-certification-content {
            float: right;
            width: 950px;
        }
    }
}

@media only screen and (max-width:980px) {
    .wl-pro-intro-main-wrapper {
        .ph-head-menu {
            display: none;
        }

        .wl-project-introduction .wl-certification-content {
            float: none;
            width: 100%;
        }
    }

    .wl-project-introduction-wrapper {
        margin-top: 10px;
        padding: 0 20px 10px;

        .wl-certification-lecturer-conte {
            width: 100%;
        }

        .wl-sidebar-menu {
            .pro-intro-menu-ul {
                margin-top: 10px;

                .pro-intro-ul-li {
                    width: 25%;

                    a {
                        display: block;
                        width: 100%;
                    }
                }
            }

            .pro-intro-ul-li {
                float: left;
            }

            .a-stand-link {
                float: left;
                padding-left: 0;
                height: 35px;
                line-height: 35px;
                font-size: 13px;
                width: 100px;
                text-align: center;
                background: #e9ebf0;
                color: #000;

                .wl-icon-xiangyou {
                    display: none;
                }
            }

            .linkActive {
                background: #2d82ff;
                color: #fff;
            }
        }

        .wl-certification-content {
            .authen-hade-title {
                display: none;
            }

            .border-class-content {
                margin-top: 10px;
                padding: 10px 10px 30px;

                .exam-text-content {
                    font-size: 13px;
                }
            }

            .h3-wl-title {
                margin-top: 10px;
                font-size: 16px;
                border-bottom: 1px solid #e9ebf0;
                padding-bottom: 10px;
            }
        }

        .wl-lecturer-back {
            display: none;
        }

        .wl-sidebar-menu,
        .wl-certification-content {
            float: none;
        }

        .wl-sidebar-menu {
            width: 100%;
        }
    }
}
</style>
